export default __webpack_public_path__ + "static/media/User.484f7590.svg";